import { jsx, jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import FocusLock from "@ingka/focus-lock";
import cx from "classnames";
import { escFunction, handleAnimationEnd, onBackdropClick, onVisibleChanged, enter, releaseBody } from "@ingka/modal-shared";
const Modal = (props) => {
  const {
    className,
    visible = false,
    prefix = "",
    children,
    handleCloseBtn,
    focusLockProps = {},
    keepContentMounted = false,
    escapable = true,
    onModalClosed = () => void 0,
    onModalOpened = () => void 0,
    onKeyDown = () => void 0,
    scrollLock = true,
    ...other
  } = props;
  const [isOpen, setIsOpen] = React.useState(visible);
  const [animationMountHelper, setAnimationMountHelper] = React.useState(false);
  const animationFrameRef = React.useRef(-1);
  const baseClass = `${prefix}modal-wrapper`;
  useEffect(
    () => {
      onVisibleChanged(prefix, visible, scrollLock, isOpen, setIsOpen, setAnimationMountHelper);
    },
    [visible]
  );
  useEffect(() => {
    if (visible)
      enter(setIsOpen, scrollLock, prefix);
    return () => {
      if (scrollLock)
        releaseBody(prefix);
      cancelAnimationFrame(animationFrameRef.current);
    };
  }, []);
  const overlayStyle = cx(
    baseClass,
    isOpen ? `${baseClass}--open` : `${baseClass}--close`,
    className
  );
  const backdropStyle = cx(
    `${baseClass}__backdrop`,
    `${baseClass}__backdrop--dark`
  );
  const hookedModal = React.Children.map(
    children,
    (child) => React.cloneElement(child, {
      open: isOpen,
      closeBtnClick: handleCloseBtn,
      prefix
    })
  );
  const onKeyDownHandler = (e) => {
    onKeyDown(e);
    escFunction(
      e,
      baseClass,
      escapable,
      // eslint-disable-next-line no-shadow
      handleCloseBtn,
      setIsOpen,
      setAnimationMountHelper
    );
  };
  const onMouseDownHandler = (e) => {
    onBackdropClick(
      e,
      escapable,
      // eslint-disable-next-line no-shadow
      handleCloseBtn
    );
  };
  const onAnimationEndHandler = (e) => {
    handleAnimationEnd(
      e,
      animationFrameRef.current,
      isOpen,
      onModalOpened,
      onModalClosed,
      scrollLock,
      animationMountHelper,
      setAnimationMountHelper,
      prefix
    );
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...other,
      onKeyDown: onKeyDownHandler,
      className: overlayStyle,
      tabIndex: -1,
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: backdropStyle,
            onMouseDown: onMouseDownHandler,
            onAnimationEnd: onAnimationEndHandler
          }
        ),
        (keepContentMounted || isOpen || animationMountHelper) && /* @__PURE__ */ jsx(
          FocusLock,
          {
            prefix,
            autoFocus: true,
            onEscaped: handleCloseBtn,
            locked: isOpen,
            ...focusLockProps,
            children: hookedModal
          }
        )
      ]
    }
  );
};
var Modal_default = Modal;
export {
  Modal_default as default
};
